import React from 'react';

class Register extends React.Component {
  constructor(props) {
    console.log(props)
    super(props);
    this.state = {
      name: '',
      location: '',
      company: '',
      description: '',
      rateofescape: '',
      image: '',
      duration: '',
      playedon: ''
    }
  }

  onNameChange = (event) => {
    this.setState({name: event.target.value})
  }

  onLocationChange = (event) => {
    this.setState({location: event.target.value})
  }

  onCompanyChange = (event) => {
    this.setState({company: event.target.value})
  }

  onDescriptionChange = (event) => {
    this.setState({description: event.target.value})
  }

  onRateofEscapeChange = (event) => {
    this.setState({rateofescape: event.target.value})
  }

  onImageChange = (event) => {
    this.setState({image: event.target.value})
  }

  onDurationChange = (event) => {
    this.setState({duration: event.target.value})
  }

  onPlayedonChange = (event) => {
    this.setState({playedon: event.target.value})
  }
  

  onSubmitSignIn = () => {
    fetch('https://rooms-escape.com/room/create', {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        name: this.state.name,
        location: this.state.location,
        company: this.state.company,
        description: this.state.description,
        rateofescape: this.state.rateofescape,
        image: this.state.image,
        duration: this.state.duration,
        playedon: this.state.playedon
      })
    })
      .then(response => {
        if (response.status === 201) {
          alert('Room Registered!')
          this.props.handleRegister()
        }
      })
      .catch(err => console.log(err))
  }

  render() {
    const diafora = [
        {name: 'name', fun: this.onNameChange },
        {name: 'company', fun: this.onCompanyChange },
        {name: 'location', fun: this.onLocationChange },
        {name: 'rate', fun: this.onRateofEscapeChange },
        {name: 'duration', fun: this.onDurationChange },
        {name: 'image', fun: this.onImageChange },
        {name: 'description', fun: this.onDescriptionChange },
  ]
    return (
      <article className="br3 ba b--black-10 mv4 w-100 w-50-m w-25-l mw6 shadow-5 center">
        <main className="pa4 black-80">
          <div className="measure">
            <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
              <legend className="f1 fw6 ph0 mh0">Register</legend>
              {diafora.map((diaf,index )=> {
                return <div key = {index} className="mt3">
                <label className="db fw6 lh-copy f6" htmlFor="name">{diaf.name}</label>
                <input
                  className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"                  
                  type="text"
                  name={diaf.name}
                  id={diaf.name}
                  onChange={diaf.fun}
                />
              </div>
              })}
              <div className="mt3">
                <label className="db fw6 lh-copy f6" htmlFor="name">Played On</label>
                <input
                  className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"                  
                  type="datetime-local"
                  name='played'
                  id='played'
                  onChange={this.onPlayedonChange}
                />
              </div>    
            </fieldset>
            <div className="">
              <input
                onClick={this.onSubmitSignIn}
                className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib"
                type="submit"
                value="Register"
              />
            </div>
          </div>
        </main>
      </article>
    );
  }
}

export default Register;


// WEBPACK FOOTER //
// ./src/Register/Register.js